<template>
  <v-expansion-panels
    :value="matchOpenedItem"
    class="elevation-0"
    accordion
    multiple
    dense
    flat
  >
    <template v-for="(nav, idx) in navs">
      <v-expansion-panel
        v-if="!nav.dontExist"
        :key="`${nav.name} - ${idx}`"
        :readonly="!nav.expandable"
        :class="{ variant }"
        class="panel elevation-0"
      >
        <v-expansion-panel-header
          v-if="!nav.hidden"
          #default="{ open }"
          class="panel_header elevation-0 pa-0"
          hide-actions
        >
          <!-- :class="!nav.path && 'cursor-normal'" -->
          <div v-if="open" class="pos-a fill-all Primary100 b-rad-4"></div>
          <v-list-item
            :to="nav.children && !nav.showPath ? '' : nav.path"
            :disabled="nav.disabled"
            :class="{
              'v-list-item--active':
                nav.name == 'exhibitions' &&
                getCurrentRoute.name.includes('exhibitions')
            }"
            v-if="getCurrentRoute.name"
            active-class="add_bar active"
            dense
            nav
          >
            <div class="active_bar"></div>
            <div class="active_bg"></div>
            <v-list-item-icon v-if="nav.icon">
              <template v-if="/custom-/.test(nav.icon)">
                <v-avatar size="24">
                  <img
                    :src="
                      require(`@/assets/icons/${nav.icon.replace(
                        'custom-',
                        ''
                      )}.svg`)
                    "
                    v-show="includedRoute[0] != nav.path"
                  />
                  <img
                    :src="
                      require(`@/assets/icons/${nav.icon.replace(
                        'custom-',
                        ''
                      )}_active.svg`)
                    "
                    v-if="includedRoute[0] == nav.path"
                    v-show="includedRoute[0] == nav.path"
                    alt=""
                  />
                </v-avatar>
                <!-- <v-avatar size="24" v-if="nav.name.includes('exhibitions')">
                  <img
                    :src="
                      require(`@/assets/icons/${nav.icon.replace(
                        'custom-',
                        ''
                      )}.svg`)
                    "
                    v-show="!includedRoute[1].includes('exhibitions')"
                  />
                  {{ `${includedRoute[1].includes('exhibitions')} ` }}
                  <img
                    :src="
                      require(`@/assets/icons/${nav.icon.replace(
                        'custom-',
                        ''
                      )}_active.svg`)
                    "
                    v-if="includedRoute[1].includes('exhibitions')"
                    v-show="includedRoute[1].includes('exhibitions')"
                    alt=""
                  />
                </v-avatar> -->
              </template>
              <template v-else>
                <v-icon>{{ nav.icon }}</v-icon>
              </template>
            </v-list-item-icon>

            <SizeBox width="14" />

            <v-list-item-content>
              <v-list-item-title
                class="d-flex align-center full-width text-body-1"
              >
                {{ $t(nav.i18nKey) }}
                <v-spacer></v-spacer>
                <v-icon v-if="nav.expandable" :class="{ rotate180: open }">
                  mdi-chevron-down
                </v-icon>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-expansion-panel-header>

        <v-expansion-panel-content
          v-if="nav.children && nav.expand"
          class="panel_content elevation-0 pa-0"
          :class="{ transparent: !nav.expandable }"
        >
          <nav-items :navs="nav.children" :variant="variant" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>
  </v-expansion-panels>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NavItems',

  props: {
    navs: {
      type: Array,
      default: () => []
    },

    variant: {
      type: Boolean,
      default: false
    },

    root: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      open: false,
      matchOpenedItem: []
    };
  },

  mounted() {
    this.calcOpenItem();
  },

  computed: {
    ...mapGetters({
      getIncludedRoute: 'app/getIncludedRoute',
      getCurrentRoute: 'app/getCurrentRoute'
    }),
    includedRoute: {
      immediate: true,
      get() {
        return this.getIncludedRoute(this.$route.name)
          .filter(({ path }) => path != '/')
          .map(({ path }) => path);
      }
    }
  },

  watch: {
    includedRoute(oldv, newv) {
      this.calcOpenItem();
    }
  },

  methods: {
    calcOpenItem() {
      setTimeout(() => {
        const displayArray = [];
        if (this.root) {
          this.navs.forEach((el, i) => {
            displayArray.push(i);
          });

          this.matchOpenedItem = displayArray;
          return;
        }
        this.navs.filter(({ path }, i) => {
          if (path === '/' || this.includedRoute.includes(path)) {
            displayArray.push(i);
            return true;
          }
        });

        this.matchOpenedItem = displayArray;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
$border_radius: 8px;

.panel {
  background-color: #ffffff00 !important;

  :deep(.v-expansion-panel-content__wrap) {
    padding: 0 !important;
    padding-left: 16px !important;
    padding-right: 16px !important;
    .v-ripple__container {
      border-radius: 8px;
    }
  }
  &.variant {
    :deep(.v-expansion-panel-content__wrap) {
      padding: 0 !important;
    }
  }
}

.active_bar {
  $bar_width: 3px;
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);

  background-color: $primary;
  width: $bar_width;
  height: 50%;
  border-radius: $bar_width;
  display: none;
}

.add_bar {
  .active_bar {
    display: block;
    z-index: 1;
    box-shadow: -2px 0 4px 0px var(--color-primary);
  }

  .active_bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: $neutral700;
    border-radius: $border_radius;
  }
}

.panel_header {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 56px !important;

  :deep(.v-list-item .v-list-item__content) {
    color: $neutral100;
    z-index: 1;
  }
  :deep(.v-list-item--link:before) {
    background-color: $neutral700 !important;
    border-radius: $border_radius;
  }

  ::v-deep .v-list-item__icon {
    align-self: center;
    margin-top: 10px;
  }

  :deep(.v-expansion-panel-header__icon) {
    position: absolute;
    height: 100%;
    margin: 0;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
  }

  :deep(.rotate180) {
    transform: rotate(180deg);
  }
}

.nav_divider {
  position: absolute;
  width: 95%;
  bottom: 0;
  right: 0;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0 19px 16px;
}
.v-list-item {
  height: 100% !important;
  min-height: 56px !important;
  .v-list-item__icon * {
    color: $neutral100 !important;
  }
}
.v-list-item--link:before {
  border-radius: 6px;
}
.v-list-item__content {
  position: relative;
}
.v-list-item__title {
  color: $neutral400;
  line-height: 1.5rem;
}
.v-list-item--active {
  background-color: $neutral700 !important;
  border-radius: $border_radius;
  color: transparent;
  .v-list-item__title {
    color: $primary500 !important;
  }
  // .v-list-item__icon * {
  //   color: $Surface !important;
  // }
}
</style>
